module.exports = __webpack_public_path__ + "vue_assets/img/img_setting_age_of_exploration.b8bce471.png";